/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UpdateKeyValuePairPayload } from 'common/stores/redux/interfaces';
import type { AdminAccountState } from 'admin/stores/redux/AdminAccount/interfaces';
import { Account } from 'common/types';

const initialState: AdminAccountState = {
    initialized: false,
    account: {
        active: false,
        availableForTesting: false,
        detailsEdit: false,
        email: '',
        financialSyncStatus: undefined,
        financialSyncTime: undefined,
        firstName: '',
        fullName: '',
        id: null,
        lastName: '',
        accountLastLogin: undefined,
    },
};

export const adminAccountSlice = createSlice({
    name: 'adminAccount',
    initialState,
    reducers: {
        init(state: AdminAccountState, action: PayloadAction<Account>) {
            state.initialized = true;
            state.account = action.payload;
        },
        updateKeyValuePair(
            state: AdminAccountState,
            action: PayloadAction<UpdateKeyValuePairPayload>
        ) {
            const { key, value } = action.payload;
            const update: Record<string, unknown> = {};
            if (Array.isArray(key)) {
                for (let idx = 0; idx < key.length; idx++) {
                    update[key[idx]] = value[idx];
                }
            } else {
                update[key] = value;
            }
            state.account = {
                ...state.account,
                ...update,
            } as Account;
        },
        replace(state: AdminAccountState, action: PayloadAction<Account>) {
            state.account = action.payload;
        },
    },
});

export const { init, updateKeyValuePair, replace } = adminAccountSlice.actions;

export default adminAccountSlice.reducer;
